import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  FormFeedback,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';
import SelectAPI from './SelectAPI';
import Strings from '../strings/Strings';
import BaseService from '../services/BaseService';
import Loader from './Loader';

class SpotTypeCreate extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      name: '',
      nameInvalid: false,
      loading: false,
      error_message: "",
      color_message: "",
      spot_types_period: null,
      spotTypesPeriodInvalid: false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggle = this.toggle.bind(this);
    this.valid_field = this.valid_field.bind(this);
    this.register = this.register.bind(this);
  }
  // dispatching an action based on state change
  componentWillUpdate(nextProps, nextState) {
    if (nextProps.editing !== null && nextProps.editing !== this.props.editing) {
      this.setState({
        name: nextProps.editing.name,
        spot_types_period: nextProps.editing.spot_type_periods
      })
    }
  }
  handleInputChange (event) {
    // get target
    const target = event.target;
    // if checkbox or input field
    const value = target.type === 'checkbox' ? target.checked: target.value;
    // get tag name
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  toggle(refresh){
    this.setState({
      name: "",
      nameInvalid: false,
      spot_types_period: null,
      color_message: '',
      spotTypesPeriodInvalid: false,
    });
    this.props.toggle(refresh);
  }
  valid_field(){
    var invalid = false;
    if(this.state.name.trim().length<=0 || this.state.name.trim().length>50){
      invalid = true;
      this.setState({nameInvalid: true});
    } else {
      this.setState({nameInvalid: false});
    }
    if(this.state.spot_types_period===null || this.state.spot_types_period.length<=0){
      invalid = true;
      this.setState({spotTypesPeriodInvalid: true});
    } else {
      this.setState({spotTypesPeriodInvalid: false});
    }

    // Valid inputs
    if(invalid===true){
      return false;
    }

    // Success
    return true;
  }
  register() {
    if(!this.valid_field()){
      return;
    }
    this.setState({loading: true});
    var msg_success = 'cadastrado';
    let url = BaseService.ENDPOINT + "admin/spot-type";
    if(this.props.editing !== null){
      url += "/"+this.props.editing.id;
      msg_success = 'alterado';
    }
    var form = new FormData();
    form.append("name", this.state.name);
    form.append("spot_type_period_id", this.state.spot_types_period.id);
		return fetch(url, {
      method: 'POST',
      headers: new Headers({
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + this.props.user.access_token,
      }),
      body: form
    })
		.then((response) => response.json())
		.then((json) => {
			if(json.return.code === 1){
        this.setState({
          loading: true,
          error_message: 'Tipo '+msg_success+' com sucesso!',
          color_message: 'success'
        });
      } else if(json.return.code === 403 || json.return.code === 500){
        window.location = '/';
      } else {
        this.setState({
          loading: true,
          error_message: json.return.message
        });
      }
		});
  }
  render() {
    return (
      <Modal isOpen={this.props.visible} >
        <ModalHeader>{(this.props.editing!==null?'Editar':'Criar')} Tipo</ModalHeader>
          <ModalBody hidden={this.state.loading}>
            <Form>
              <FormGroup>
                {(this.props.editing!==null?<Label>Descrição do Tipo</Label>:'')}
                <Input
                  type="text"
                  maxLength={50}
                  name="name"
                  placeholder="Descrição do Tipo"
                  value={this.state.name}
                  onChange={this.handleInputChange}
                  invalid={this.state.nameInvalid}>
                </Input>
                <FormFeedback>{Strings.required_field}</FormFeedback>
              </FormGroup>
              <SelectAPI
                label={(this.props.editing!==null?Strings.rules:'')}
                name="spot_types_period"
                placeholder={"Selecione uma "+Strings.rules}
                access_token={this.props.user.access_token}
                api="admin/spot-type-periods"
                selectedOption={this.handleInputChange}
                value={this.state.spot_types_period}
                invalid={this.state.spotTypesPeriodInvalid} 
                formFeedbackMsg={Strings.required_field}
                multi={false}
              />
            </Form>
          </ModalBody>
          <Loader
            body={ModalBody}
            hidden={!this.state.loading}
            message={this.state.error_message}
            color_message={this.state.color_message}
            onClose={() => this.setState({loading: false, error_message: '', color_message: ''})}
            onCloseSuccess={() => {this.toggle(true); this.setState({loading: false, error_message: '', color_message: ''});}}
          />
          <ModalFooter hidden={this.state.loading} >
            <Button outline color="secondary" onClick={this.register}>Salvar</Button>
            <Button outline color="danger" onClick={() => this.toggle(false)}>Cancelar</Button>
        </ModalFooter>
    </Modal>
    )
  }
}
export default SpotTypeCreate;


// WEBPACK FOOTER //
// ./src/components/SpotTypeCreate.js